import {
    Box,
    Popover,
} from '@mui/material';

import CheckIcon from '@mui/icons-material/Check';
import { DataGrid, gridClasses, } from '@mui/x-data-grid';
import RoleChip from './RoleChip';

import { useTranslation } from 'react-i18next';

const roles = [
  { field: 'employee', label: 'Mitarbeiter' },
  { field: 'reporter', label: 'Reporter' },
  { field: 'hr', label: 'HR-Manager' },
  { field: 'maintainer', label: 'Maintainer' },
  { field: 'administrator', label: 'Administrator' },
];

const permissions = [
  { id: 0, label: 'Arbeitszeiterfassung', employee: true, reporter: true, hr: true, maintainer: true, administrator: true },
  { id: 1, label: 'Monatliche Arbeitszeitfreigabe', employee: true, reporter: true, hr: true, maintainer: true, administrator: true },
  { id: 2, label: 'Statusübersicht über Arbeitszeitfreigaben aller Mitarbeitenden', employee: false, reporter: true, hr: false, maintainer: false, administrator: false },
  { id: 3, label: 'Erzeugung von Arbeitszeitnachweisen', employee: false, reporter: true, hr: false, maintainer: false, administrator: false },
  { id: 4, label: 'Verwaltung von Mitarbeitendenstammdaten', employee: false, reporter: false, hr: true, maintainer: false, administrator: false },
  { id: 5, label: 'Institutsspezifische Konfiguration des Tools', employee: false, reporter: false, hr: false, maintainer: true, administrator: false },
  { id: 6, label: 'Nutzerzugänge und Rollenvergabe', employee: false, reporter: false, hr: false, maintainer: false, administrator: true },
];

function RolePopover(props) {
  const { t } = useTranslation();

  const columns = [
    { field: 'permission', headerName: t('berechtigung', { ns: 'userAccessPage', defaultValue: 'Berechtigung' }), flex: 1, sortable: false, filterable: false },
    ...roles.map((role) => ({
      field: role.field,
      headerName: role.label,
      sortable: false,
      flex: 0.5,
      headerAlign: 'center',
      align: 'center',
      renderHeader: () => <RoleChip name={role.label} />,
      renderCell: (params) => params.value && <CheckIcon sx={{ color: 'grey' }} />,
    })),
  ];

  const rows = permissions.map((permission) => ({
    permission: permission.label,
    ...permission,
  }));

  return (
    <>
      <Popover
        {...props}
      >
        <Box sx={{ p: '10px', width: '1000px' }}>
          <DataGrid
            columns={columns}
            rows={rows}
            hideFooter={true}
            disableColumnMenu
            disableColumnFilter
            disableRowSelectionOnClick
            getRowHeight={() => 'auto'}
            sx={{
              [`& .${gridClasses.cell}`]: {
                py: 1,
              },
            }}

          />
        </Box>
      </Popover>
    </>
  )
}

export default RolePopover
